module.exports = __webpack_public_path__ + "img/no-resource.98336599.png";